import { createContext } from "react";

const DebtScreen = createContext<any>(null);

export default DebtScreen;
